<template>
  <div class="w-full">
    <div class="bg-paleta-2 m-1 py-2 text-white text-2xl font-bold">{{ cadenaImporte }}</div>
    <div class="flex justify-center">
      <BotonCalculadora v-for="digito in digitosPrimeraFila" :key="digito" v-bind:numero="digito" v-on:clickeado="click" />
    </div>
    <div class="flex justify-center">
      <BotonCalculadora v-for="digito in digitosSegundaFila" :key="digito" v-bind:numero="digito" v-on:clickeado="click" />
    </div>
    <div class="flex justify-center">
      <BotonCalculadora v-for="digito in digitosTerceraFila" :key="digito" v-bind:numero="digito" v-on:clickeado="click" />
    </div>
    <div class="flex justify-center">
      <BotonCalculadora v-for="digito in digitosCuartaFila" :key="digito" v-bind:numero="digito" v-on:clickeado="click" />
    </div>
  </div>
</template>

<script>
import BotonCalculadora from "../components/BotonCalculadora";

export default {
  components: {
    BotonCalculadora
  },
  data: function() {
    return {
      cadenaImporte: "0",
      digitosPrimeraFila: ["1", "2", "3"],
      digitosSegundaFila: ["4", "5", "6"],
      digitosTerceraFila: ["7", "8", "9"],
      digitosCuartaFila: ["C", "0", "<"]
    };
  },
  methods: {
    click: function(numero) {
      if (numero === "C") {
        this.cadenaImporte = "0";
        this.$emit("nuevo-importe", parseInt(this.cadenaImporte));
        return;
      }

      if (numero == "<") {
        if (this.cadenaImporte.length > 1) {
          this.cadenaImporte = this.cadenaImporte.slice(0, -1);
        } else {
          this.cadenaImporte = "0";
        }
        this.$emit("nuevo-importe", parseInt(this.cadenaImporte));
        return;
      }

      if (this.cadenaImporte.length == 1 && this.cadenaImporte[0] == "0") {
        this.cadenaImporte = numero;
        this.$emit("nuevo-importe", parseInt(this.cadenaImporte));
        return;
      }

      this.cadenaImporte += numero;
      this.$emit("nuevo-importe", parseInt(this.cadenaImporte));
    }
  }
};
</script>
